import React from 'react';
import {connect} from 'react-redux';
import BottomMenu from '../Presentation/Navigation/BottomMenu';
import FooterMenu from '../Presentation/Navigation/FooterMenu';

class Footer extends React.Component {
    render() {
        const currentDate = new Date();
        let currentYear = currentDate.getYear();
        if (currentYear < 1900) currentYear += 1900;

        return <footer className="footer">
            <div className="footer-top text-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Последвайте ни</h2>

                            <div className="social-links">
                                <a target="_blank" href="https://www.facebook.com/meditabgapp"
                                   className="social-link facebook"/>
                                <a target="_blank" href="https://www.instagram.com/meditabgapp"
                                   className="social-link instagram"/>
                                <a target="_blank" href="https://www.youtube.com/channel/UCd6YVeYA9flnfyVKUJU6jtw"
                                   className="social-link youtube"/>
                            </div>

                            <BottomMenu className="bottom-nav"/>
                            <FooterMenu className="footer-menu-mobile"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="copyright">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 col-sm-12">
                            <ul className="footer-copy">
                                <li>&copy; {currentYear} Medita.bg Всички права запазени.</li>
                                <li>Дизайн и разработка от <a href="http://devlabs.bg/" target="_blank">Dev Labs</a></li>
                            </ul>
                        </div>
                        <div className="col-md-4 col-sm-4 text-right">
                            <FooterMenu className="footer-menu"/>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/Containers/Footer.js